import React from 'react';
import { Doughnut } from 'react-chartjs-2';

const convertDateTimeToDate = (datetimeString) => {
  return datetimeString.substring(0, 10);
};

const CycleChart = ({ data }) => {
  if (!data) {
    return <div>No data available</div>;
  }

  // Convert date strings in the data object to date format "YYYY-MM-DD"
  const convertedData = {};
  Object.keys(data).forEach((key) => {
    convertedData[convertDateTimeToDate(key)] = data[key];
  });

  // Generate unique random colors
  const backgroundColor = Array.from({ length: Object.keys(convertedData).length }, () => `#${Math.floor(Math.random()*16777215).toString(16)}`);

  const chartData = {
    labels: Object.keys(convertedData),
    datasets: [
      {
        data: Object.values(convertedData),
        backgroundColor,
        hoverBackgroundColor: backgroundColor,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: true,
  };

  return <Doughnut data={chartData} options={options} />;
};

export default CycleChart;
